import { Component, OnInit, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { LandingPage } from 'src/app/landing-page/models';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: false,
})
export class FooterComponent implements OnInit {
  private store = inject(Store);

  readonly menuItems = input<LandingPage[]>([]);
  readonly schema = input<any>();
  readonly socials = input<[]>([]);
  readonly domain = input<string>('');
  year = new Date().getFullYear();

  ngOnInit(): void {
    // this.schema = {
    //   '@context': 'http://schema.org',
    //   '@type': this.dict.transform('json-ld-meta-type'),
    //   'name': this.dict.transform('meta-titel'),
    //   'url': this.domain,
    //   'logo': `${this.domain}/assets/gfx/logo-spoorzone.svg`,
    //   'contactPoint': {
    //     '@type': 'ContactPoint',
    //     'email': this.dict.transform('contact-email'),
    //     'contactType': 'customer service',
    //   },
    //   'sameAs': [],
    // };

    this.socials().forEach(s => {
      const socialLink = s; // to do config with social buttons
      this.schema().sameAs.push(socialLink);
    });
  }

  openCookie() {
    this.store.dispatch(ShowCookieSettings());
  }
}
